import { gql } from '@apollo/client';

export const USE_DEBT_MUTATION = gql`
  mutation UseDebt {
    useDebt
  }
`;

export const USE_DEBT_QUERY = gql`
  query canUseDebt {
    canUseDebt
  }
`;
